<template>
  <div class="row">
    <div class="col">
      <div class="row">
        <div class="col-lg-3 lbl">
          <label>Entité:</label>
        </div>
        <div class="col-lg-9">
          <Dropdown
              class="input-width-100"
              v-model="entite"
              :options="entiteLibelles"
              optionValue="valeur"
              optionLabel="texte"
              v-on:keyup.enter="imprimer"
              scrollHeight="700px"
              :showClear="true"
          />
        </div>
      </div>
    </div>
    <div class="col">
      <div class="row">
        <div class="col-lg-3 lbl">
          <label>Site d'origine:</label>
        </div>
        <div class="col-lg-9">
          <Dropdown
              class="input-width-100"
              v-model="siteOrigine"
              :options="sitesLibelles"
              optionValue="valeur"
              optionLabel="texte"
              @:keyup.enter="imprimer"
              scrollHeight="205px"
              :showClear="true"
          />
        </div>
      </div>
    </div>
  </div>

  <template v-if="cacherChamps == false">
    <div class="row">
      <div class="col">
        <div class="row">
          <div class="col-lg-3 lbl">
            <label>Genre:</label>
          </div>
          <div class="col-lg-9">
            <Dropdown
                class="input-width-100"
                v-model="genre"
                :options="genresLibelles"
                optionValue="valeur"
                optionLabel="texte"
                @:keyup.enter="imprimer"
                scrollHeight="205px"
                :showClear="true"
            />
          </div>
        </div>
      </div>
      <div class="col"></div>
    </div>

    <div class="row">
      <div class="col">
        <div class="row">
          <div class="col-lg-3 lbl">
            <label>Nature:</label>
          </div>
          <div class="col-lg-9">
            <Dropdown
                class="input-width-100"
                v-model="nature"
                :options="naturesLibelles"
                optionValue="valeur"
                optionLabel="texte"
                @:keyup.enter="imprimer"
                scrollHeight="205px"
                :showClear="true"/>
          </div>
        </div>
      </div>
      <div class="col"></div>
    </div>

    <div class="row">
      <div class="col">
        <div class="row">
          <div class="col-lg-3 lbl">
            <label>Type:</label>
          </div>
          <div class="col-lg-9">
            <Dropdown
                class="input-width-100"
                v-model="type"
                :options="typeLibelles"
                optionValue="valeur"
                optionLabel="texte"
                v-on:keyup.enter="imprimer"
                scrollHeight="700px"
                :showClear="true"
            />
          </div>
        </div>
      </div>
      <div class="col"></div>
    </div>

    <div class="row">
      <div class="col">
        <div class="row">
          <div class="col-lg-3 lbl">
            <label>Catégorie:</label>
          </div>
          <div class="col-lg-9">
            <Dropdown
                class="input-width-100"
                v-model="categorie"
                :options="categorieLibelles"
                optionValue="valeur"
                optionLabel="texte"
                v-on:keyup.enter="imprimer"
                scrollHeight="700px"
                :showClear="true"
            />
          </div>
        </div>
      </div>
      <div class="col"></div>
    </div>

    <div class="row">
      <div class="col">
        <div class="row">
          <div class="col-lg-2 lbl">
            <label>Intervenant:</label>
          </div>
          <div class="col-lg-10">
            <div v-if="intervenantsLoading == true" class="">
              <vue-loaders name="ball-beat"></vue-loaders>
            </div>
            <div v-else>
              <Dropdown
                  class="input-width-100"
                  v-model="intervenant"
                  :options="intervenantLibelles"
                  optionValue="codeProfil"
                  optionLabel="description"
                  v-on:keyup.enter="imprimer"
                  scrollHeight="700px"
                  :showClear="true"
                  filter
                  filterPlaceholder="Rechercher..."
                  filterMatchMode="startsWith"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="col-3"></div>
    </div>
  </template>

  <template v-if="cacherChampTypeConsignation == false">
    <div class="row">
      <div class="col">
        <div class="row">
          <div class="col-lg-3 lbl">
            <label>Type de consignation:</label>
          </div>
          <div class="col-lg-9">
            <div class="col">
              <Dropdown
                  v-model="typeConsignation"
                  :options="typesConsignationLibelles"
                  optionValue="valeur"
                  optionLabel="texte"
                  scrollHeight="205px"
                  :showClear="true"/>
            </div>
          </div>
        </div>
      </div>
      <div class="col"></div>
    </div>
  </template>

  <div class="row">
    <div class="col">
      <div class="row">
        <div class="col-lg-3 lbl">
          <label>Du:</label>
        </div>
        <div class="col-lg-9">
          <CustomInputDate
              class="input-width-100"
              type="date"
              max="9999-12-31"
              v-model="dateDu"
              v-on:keyup.enter="imprimer"
          />
        </div>
      </div>
    </div>
    <div class="col">
      <div class="row">
        <div class="col-lg-3 lbl">
          <label>Au:</label>
        </div>
        <div class="col-lg-9">
          <CustomInputDate
              class="input-width-100"
              type="date"
              max="9999-12-31"
              v-model="dateAu"
              v-on:keyup.enter="imprimer"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import CustomInputDate from '../../Commun/CustomInputDate.vue'

export default {
  name: "CritereRechercheConsignation",
  emits: ['imprimer'],
  components: {
    CustomInputDate
  },
  props: {
    cacherChamps: {
      type: Boolean,
      default: false,
    },
    cacherChampTypeConsignation: {
      type: Boolean,
      default: false,
    },
    entiteDefault: {
      type: Number,
      default: null,
    },
    siteDefault: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      entite: null,
      siteOrigine: null,
      genre: null,
      nature: null,
      type: null,
      categorie: null,
      intervenant: null,
      typeConsignation: null,
      dateDu: null,
      dateAu: null,

      entiteLibelles: [],
      sitesLibelles: [],
      genresLibelles: [],
      naturesLibelles: [],
      typeLibelles: [],
      categorieLibelles: [],
      intervenantLibelles: [],
      typesConsignationLibelles: [],

      intervenantsLoading: false,
      critereRechercheConsignationVO: {}
    };
  },

  computed: {
    ...mapGetters({
      jeton: 'cardex/jeton',
      profil: 'cardex/profil',
    }),
  },

  methods: {
    assignerListe(entiteDecision) {
      this.entiteLibelles = entiteDecision.entite.libelles;
      this.typesConsignationLibelles = entiteDecision.typeConsignation.libelles;
      this.entite = this.entiteDefault;
      this.siteOrigine = this.siteDefault;
      this.dateDefault();
    },
    dateDefault() {
      let dateDefaut = new Date();
      this.dateDu = this.$commun.formatDate(dateDefaut.setDate(dateDefaut.getDate() - 7));
      this.dateAu = this.$commun.formatDate(new Date());
    },
    getCritereRecherche() {
      if (this.dateAu !== null && this.dateAu !== undefined) {
        this.critereRechercheConsignationVO.dateAu = new Date(this.dateAu);
      }
      if (this.dateDu !== null && this.dateDu !== undefined) {
        this.critereRechercheConsignationVO.dateDu = new Date(this.dateDu);
      }

      this.critereRechercheConsignationVO.categorie = this.categorie;
      this.critereRechercheConsignationVO.entite = this.entite;
      this.critereRechercheConsignationVO.genre = this.genre;
      this.critereRechercheConsignationVO.intervenant = this.intervenant;
      this.critereRechercheConsignationVO.nature = this.nature;
      this.critereRechercheConsignationVO.siteOrigine = this.siteOrigine;
      this.critereRechercheConsignationVO.type = this.type;
      this.critereRechercheConsignationVO.typeConsignation = this.typeConsignation;
      return this.critereRechercheConsignationVO;
    },
    imprimer() {
      this.$emit("imprimer");
    },
  },

  watch: {
    entite: function (val) {
      if (val !== null && val !== undefined) {
        this.$store.dispatch('consignation/obtenirDecisionLibelleVOsDeCriteresAction', {
          libelleChange: 'Site',
          nouvelleValeur: [val]
        })
            .then((res) => {
              this.sitesLibelles = res.data;
              this.genre = null;
            })
        this.$store.dispatch('consignation/obtenirDecisionLibelleVOsDeCriteresAction', {
          libelleChange: 'Genre',
          nouvelleValeur: [val]
        })
            .then((res) => {
              this.genresLibelles = res.data;
              this.genre = null;
            })
      } else {
        this.site = null;
        this.genre = null;
        this.genresLibelles = [];
        this.sitesLibelles = [];
      }
    },
    siteOrigine: function (val) {
      if (val !== null && val !== undefined) {
        this.intervenantsLoading = true;
        this.$store.dispatch('consignation/obtenirListeIntervenantsAction', {
          site: val
        })
            .then((res) => {
              this.intervenantLibelles = res.data.sort(this.$commun.compareIntervenant);
              this.intervenantsLoading = false;
            })
      } else {
        this.intervenantLibelles = [];
        this.intervenant = null;
      }
    },
    genre: function (val) {
      if (val !== null && val !== undefined) {
        this.$store.dispatch('consignation/obtenirDecisionLibelleVOsDeCriteresAction', {
          libelleChange: 'Nature',
          nouvelleValeur: val
        })
            .then((res) => {
              this.naturesLibelles = res.data;
              this.nature = null;
            })
      } else {
        this.nature = null;
        this.naturesLibelles = [];
      }
    },
    nature: function (val) {
      if (val !== null && val !== undefined) {
        this.$store.dispatch('consignation/obtenirDecisionLibelleVOsDeCriteresAction', {
          libelleChange: 'Type',
          nouvelleValeur: val
        })
            .then((res) => {
              this.typeLibelles = res.data;
              this.type = null;
            })
      } else {
        this.type = null;
        this.typeLibelles = [];
      }
    },
    type: function (val) {
      if (val !== null && val !== undefined) {
        this.$store.dispatch('consignation/obtenirDecisionLibelleVOsDeCriteresAction', {
          libelleChange: 'Categorie',
          nouvelleValeur: val
        })
            .then((res) => {
              this.categorieLibelles = res.data;
              this.categorie = null;
            })
      } else {
        this.categorie = null;
        this.categorieLibelles = [];
      }
    },
  }
}
</script>